/* Maison Textile (23/09/2026, accord d'Alex) : au clic sur une puce « Accès rapide » d'une page collection,
   on remplace seulement le contenu de la page (bannière, tuiles, grille) sans recharger l'en-tête, comme
   Bonsoirs. Le lien reste un vrai lien (nouvelle adresse, retour arrière, ouverture dans un onglet).
   Au moindre problème (réseau, page inattendue), on retombe sur un chargement normal. */
(function () {
  if (window.__mtSoftNav) return;
  window.__mtSoftNav = true;
  var busy = false, used = false;
  function loadedSrc(src) {
    return [].some.call(document.scripts, function (s) { return s.src && s.src === src; });
  }
  function swap(url, push) {
    if (busy) return;
    busy = true;
    var main = document.getElementById('MainContent');
    if (!main || !window.fetch || !window.DOMParser) { location.href = url; return; }
    main.style.transition = 'opacity .15s ease';
    main.style.opacity = '.5';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok || r.redirected && new URL(r.url).pathname.indexOf('/collections/') !== 0) throw new Error('nav'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('MainContent');
        if (!next || !doc.body.className.match(/template-collection/)) throw new Error('nav');
        main.innerHTML = next.innerHTML;
        [].slice.call(main.querySelectorAll('script')).forEach(function (old) {
          var type = old.getAttribute('type') || '';
          if (type && type !== 'text/javascript' && type !== 'module') return;
          if (old.src && loadedSrc(old.src)) return;
          var s = document.createElement('script');
          [].forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
          s.textContent = old.textContent;
          old.parentNode.replaceChild(s, old);
        });
        document.title = doc.title;
        if (push) history.pushState({ mtSoftNav: true }, '', url);
        used = true;
        main.style.opacity = '';
        var header = document.querySelector('.header-section');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var chips = main.querySelector('.mt-chips__label, .mt-chips');
        var target = chips ? chips.getBoundingClientRect().top + window.scrollY - offset - 16 : 0;
        if (window.scrollY > target) window.scrollTo({ top: Math.max(0, target) });
        document.dispatchEvent(new CustomEvent('mt:softnav', { detail: { url: url } }));
        busy = false;
      })
      .catch(function () { location.href = url; });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.mt-chips__item');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    e.preventDefault();
    if (url.pathname === location.pathname && !url.search) return;
    swap(url.href, true);
  });
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.mtSoftNav) { swap(location.href, false); return; }
    if (used && !e.state) location.reload();
  });
})();
